import {GET_ROWS_SUCCESS} from "../../reducers/rowsReducer";


export const getRowsSuccess = (rows) =>{
    return {
        type: GET_ROWS_SUCCESS,
        payload: {rows}
    }
}